export default "/images/comment.png?c30d19c3b3064c9a980e902763853b85";